var path = '/var/www/mmscny-cms/src/app/common/components/tag/tag.html';
var html = "<ul style=list-style:none> <li ng-repeat=\"(idx, tag) in $ctrl.items track by $index\" class=\"tag label label-success\">{{tag}} <a class=close href ng-click=$ctrl.remove(tag)>x</a> </li> </ul> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/tag/tag.html
// module id = 748
// module chunks = 0